import React from "react";
import styled from "styled-components";

import AppText from "../../../components/Core/AppText/AppText";
import { appTheme } from "../../../theme/Theme";

interface MessageBoxProps {
	message: string;
	width?: string;
	margin?: string;
}

interface MessageBoxStylesProps {
	width?: string;
	margin?: string;
}

const MessageBox: React.FC<MessageBoxProps> = ({ message, width, margin }) => {
	return (
		<MessageBoxWrapper width={width} margin={margin}>
			<AppText size="m" color="black">
				{message}
			</AppText>
		</MessageBoxWrapper>
	);
};

export default MessageBox;

const MessageBoxWrapper = styled.div<MessageBoxStylesProps>`
	display: flex;
	flex-direction: column;
	width: ${(props) => (props.width ? props.width : "auto")};
	margin: ${(props) => (props.margin ? props.margin : "0")};
	background-color: ${appTheme.colors.COLOR_WHITE};
	padding: 8px 20px;
	position: relative;
	border-radius: 1px;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

	&::after {
		position: absolute;
		left: 5px;
		top: 0;
		width: 3px;
		background: ${appTheme.colors.COLOR_DIVIDER_GRAY};
		height: 78%;
		content: "";
		margin: auto;
		bottom: 0;
	}
`;
